module.exports = __webpack_public_path__ + "img/kitchen-dining-rugs-runners.a3ce984.jpg";